import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  "class": "dashboard fs_box_wrapper"
};
var _hoisted_2 = {
  "class": "fs_box fs_dashboard_box fs_box_narrow"
};
var _hoisted_3 = {
  "class": "fs_box_header",
  style: {
    "padding": "20px 15px",
    "font-size": "16px"
  }
};
var _hoisted_4 = {
  "class": "fs_box_body fs_padded_20"
};
var _hoisted_5 = {
  key: 0
};
var _hoisted_6 = {
  key: 0,
  "class": "text-align-center"
};
var _hoisted_7 = {
  key: 1,
  "class": "text-align-center"
};
var _hoisted_8 = {
  key: 2
};
var _hoisted_9 = {
  "class": "fcon_box_widgets"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  var _component_el_button = _resolveComponent("el-button");
  var _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, " Good " + _toDisplayString($options.greetingTime) + " " + _toDisplayString($data.me.full_name) + "! ", 1 /* TEXT */), _createElementVNode("div", _hoisted_4, [$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_skeleton, {
    rows: 3,
    animated: ""
  })])) : _createCommentVNode("v-if", true), $data.require_setup ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_cache[7] || (_cache[7] = _createElementVNode("div", {
    "class": "fcon_welcome text-align-center"
  }, [_createElementVNode("h2", null, [_createTextVNode("Thanks for installing "), _createElementVNode("b", null, "Fluent Connect")]), _createElementVNode("p", null, "Using Fluent Connect, you can easily integrate External Services or Migrate From other CRMs into FluentCRM"), _createElementVNode("hr")], -1 /* HOISTED */)), !$data.has_fluentcrm ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_cache[4] || (_cache[4] = _createElementVNode("h4", null, "To getting started please install and activate FluentCRM", -1 /* HOISTED */)), _createVNode(_component_el_button, {
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $options.installFluentCRM();
    }),
    type: "primary"
  }, {
    "default": _withCtx(function () {
      return _cache[3] || (_cache[3] = [_createTextVNode("Install and Activate FluentCRM")]);
    }),
    _: 1 /* STABLE */
  })])) : !$data.has_thrivecart ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[6] || (_cache[6] = _createElementVNode("h4", null, "Fluent Connect will let you connect your ThriveCart with FluentCRM.", -1 /* HOISTED */)), _createVNode(_component_router_link, {
    to: {
      name: 'new_integration',
      query: {
        integration_key: 'thrivecart'
      }
    },
    "class": "el-button el-button--primary btn_link"
  }, {
    "default": _withCtx(function () {
      return _cache[5] || (_cache[5] = [_createTextVNode("Connect with ThriveCart ")]);
    }),
    _: 1 /* STABLE */
  })])) : _createCommentVNode("v-if", true)], 64 /* STABLE_FRAGMENT */)) : !$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[10] || (_cache[10] = _createElementVNode("h2", null, "Awesome! Here is your quick overview", -1 /* HOISTED */)), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$router.push({
        name: 'connectors'
      });
    }),
    "class": "fcon_box_widget"
  }, [_createElementVNode("h3", null, _toDisplayString($data.stats.runners_count), 1 /* TEXT */), _cache[8] || (_cache[8] = _createElementVNode("h4", null, "Jobs Completed", -1 /* HOISTED */))]), _createElementVNode("div", {
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.$router.push({
        name: 'logs'
      });
    }),
    "class": "fcon_box_widget"
  }, [_createElementVNode("h3", null, _toDisplayString($data.stats.actions_count), 1 /* TEXT */), _cache[9] || (_cache[9] = _createElementVNode("h4", null, "Tasks Completed", -1 /* HOISTED */))])])])) : _createCommentVNode("v-if", true)])])]);
}